module.exports = __webpack_public_path__ + "static/media/Stars_Magic_AI_LLM.589a5206.svg";